import { mapActions } from "vuex";
import AuthLayout from "@/components/auth/AuthLayout.vue";
import { SLIDES_PADRAO, checklistSenha, senhaValida, emailValido } from "@/components/auth/auth.js";

const POLITICAS_URL = 'https://api.stoneup.com.br/storage/termos/CONTRATO_DE%20PRESTAC%CC%A7A%CC%83O_DE%20SERVIC%CC%A7OS_STONE_UP_MONITORA.pdf';

export default {
    components: { AuthLayout },

    data: () => ({
        slides: SLIDES_PADRAO,
        politicasUrl: POLITICAS_URL,
        snackbar: false,
        text: '',
        timeout: 2000,
        acceptedPolicies: false,
        show2: false,
        show3: false,
        loading: false,
        confirmPassword: "",
        formCad: {
            email: "",
            password: "",
            name: "",
        },
        erros: {
            name: '',
            email: '',
            password: '',
            confirm: '',
        },
    }),

    computed: {
        /** Checklist que acende conforme a senha é digitada. */
        checklist() {
            return checklistSenha(this.formCad.password);
        },
    },

    methods: {
        ...mapActions("auth", ["ActionRegister"]),

        /** Guarda a mensagem de erro do campo (ou '') e devolve se está válido. */
        validarCampo(campo) {
            const regras = {
                name: () => !!(this.formCad.name || '').trim() || 'Informe seu nome.',
                email: () => emailValido(this.formCad.email) || 'Informe um e-mail válido.',
                password: () => senhaValida(this.formCad.password) || 'A senha não atende aos requisitos.',
                confirm: () => (!!this.confirmPassword && this.confirmPassword === this.formCad.password)
                    || 'As senhas precisam ser iguais.',
            };
            const resultado = regras[campo]();
            this.erros[campo] = resultado === true ? '' : resultado;
            return resultado === true;
        },

        validar() {
            return ['name', 'email', 'password', 'confirm']
                .map((campo) => this.validarCampo(campo))
                .every(Boolean);
        },

        async submit() {
            if (!this.validar()) return;
            if (!this.acceptedPolicies) {
                this.text = "Aceite as políticas de uso para continuar";
                this.snackbar = true;
                return;
            }

            this.loading = true;
            try {
                await this.ActionRegister(this.formCad);

                this.$router.push({
                    name: "verificarEmail",
                    query: { email: this.formCad.email || null },
                });
            } catch (error) {
                if (error.status == 400) {
                    this.formCad.email = "";
                    this.text = "Este e-mail já existe";
                    this.snackbar = true;
                }
                this.loading = false;
            }
        },
    },
};
